import { UploadFileModel } from '../model';

export type UploadFileControl = Map<string, UploadFileModel>;

export type UploadFileState = 'uploading' | 'completed';

export type UploadFileError = {
  code: 'large_size' | 'extension_not_accept' | 'invalid_name' | 'upload' | 'too_small_size';
  message?: string;
};
